<template>
  <article class="manage-platform">
    <ul class="tab-service-detail">
      <li :class="{'on':time_interval===1}" @click="onShiftTap(1)"><a href="javascript:void(0);">今日</a></li>
      <li :class="{'on':time_interval===2}" @click="onShiftTap(2)"><a href="javascript:void(0);">最近7天</a></li>
      <li :class="{'on':time_interval===3}" @click="onShiftTap(3)"><a href="javascript:void(0);">本月</a></li>
    </ul>
    <group title="待办事项" class="work-title">
      <cell title="成交确认" @click.native="link('/salemanage/manage/deal')">
        <div class="work-deal" slot="value">{{summary.pending_approve_deal_num}}</div>
      </cell>
      <cell title="战败审核" @click.native="link('/salemanage/manage/review')">
        <div class="work-deal" slot="value">{{summary.pending_approve_fail_num}}</div>
      </cell>
    </group>
    <router-link :to="'/salemanage/manage/datastatistics'">
      <cell class="manage-platform-title" is-link>
        <p slot="after-title" class="status">今日动态</p>
        <p slot="value" class="more">更多</p>
      </cell>
    </router-link>
    <group class="work-no-title">
      <cell title="总呼出量">{{statistics.call_num}}</cell>
      <cell title="已联系客户数">{{statistics.contact_customer_num}}</cell>
      <cell title="新增逾期任务数">{{statistics.overdue_task_num}}</cell>
    </group>
    <router-link :to="'/salemanage/manage/datastatistics'">
      <cell class="manage-platform-title" is-link>
        <p slot="after-title" class="status">今日战绩</p>
        <p slot="value" class="more">更多</p>
      </cell>
    </router-link>
    <group class="work-no-title">
      <cell title="总接待量">{{statistics.reception_num}}批</cell>
      <cell title="首次接待量">{{statistics.first_time_reception_num}}批</cell>
      <cell title="签单客户数">{{statistics.sign_bill_num}}位</cell>
      <cell title="确认成交数">{{statistics.deal_num}}</cell>
    </group>
  </article>
</template>

<script>
import {
  Cell,
  Group
} from '@lx-frontend/cvux'
import authApi from '../../../common/auth'

export default {
  components: {
    Cell,
    Group
  },
  data () {
    return {
      authArr: [authApi.saleManage.sale_potential_customer_manage, authApi.saleManage.sale_potential_customer_view_all],
      time_interval: 1,
      summary: {
        'pending_approve_deal_num': 0,
        'pending_approve_fail_num': 0
      },
      statistics: {
        'call_num': 0,
        'contact_customer_num': 0,
        'deal_num': 0,
        'first_time_reception_num': 0,
        'overdue_task_num': 0,
        'reception_num': 0,
        'sign_bill_num': 0
      }
    }
  },
  created () {
    this.$store.state.promiseAuth.then(auth => {
      let permission = authApi.haveEveryAuth(this.authArr, auth.authList)
      if (permission) {
        this.$rest.saleManage.getSummary().then(res => {
          if (res.code === 0) {
            this.summary = res.data
          }
        }).then(() => {
          this.$rest.saleManage.getCustomersStatistics({
            time_interval: this.time_interval
          }).then(res => {
            if (res.code === 0) {
              this.statistics = res.data
            }
          })
        })
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    link (url) {
      this.$router.push(url)
    },
    onShiftTap (timeInterval) {
      if (timeInterval === this.time_interval) return
      this.time_interval = timeInterval
      this.$rest.saleManage.getCustomersStatistics({
        time_interval: timeInterval
      }).then(res => {
        if (res.code === 0) {
          this.statistics = res.data
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
